<div class="componente-importantes text-start p-5 mt-3" style="min-height:700px;">
    <div class="container-fluid ">
      <form action="" action="" class="container-fluid" method="post" (submit)="formSubmit()" [formGroup]="Step4form">
        <div class="row">

          <div class="col">
            <label for="formControlInput" class="form-label ">Titulo</label>
            <input required placeholder="Ingrese información" type="text" class=" custom-outline-input"
              formControlName="title">
          </div>

          <div class="col">
            <label for="formControlInput" class="form-label">Fecha inicio</label>
            <input required type="date" class="custom-outline-input  date " formControlName="start_date" id="start_date">
          </div>

          <div class="col">
            <label for="formControlInput" class="form-label ">Fecha termino</label>
            <input required type="date" class="custom-outline-input  date  " formControlName="end_date" id="end_date">
          </div>

          <div class="col justify-content-end">
            <label for="formFile" class="form-label">Agregar Archivo</label>
            <input (change)="onFileSelected($event)" required type="file" class="custom-outline-input form-control "
              id="formFile" style="max-width: 280px ;" formControlName="archive">
          </div>

          <div class="col-12 d-flex align-items-end justify-content-end mt-3">
            <div *ngIf="crud == 'edit' " class="mt-3 mx-5 d-flex align-items-center justify-content-center">
              <div [ngbTooltip]="'Ampliar fecha fin de proyecto según anexo'"
                class="d-flex justify-content-center align-items-end">
                <label for="extend_date" class="form-label"> Ampliar fecha</label>
                <input type="checkbox" class="ms-3 custom-outline-check form-check-input mb-1 fs-3  "
                  formControlName="extend_date" name="" id="extend_date">
              </div>
            </div>
            <button [disabled]="!Step4form.valid" class="btn btn-outline-light"> <i class="fa-solid fa-floppy-disk m-1"
                aria-hidden="true"></i> Guardar Anexo</button>
          </div>

        </div>





      </form>

    </div>
        <section class="row">
            <div class="backgroundTable row mx-2 mt-5 pb-5">
                <table datatable [dtTrigger]="dtTrigger" [dtOptions]="dtOptions"  class="componente-importantes" style="min-height:300px !important;">
                    <ng-container *ngIf="listAnex.length == 0">
                                            <div class="text-center text-white">
                                                <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                                <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                                            </div>
                    </ng-container>
                    <ng-container *ngIf="listAnex.length != 0">
                    <thead>
                        <tr class="table-info">
                            <th class="text-white text-center">Nombre Archivo</th>
                            <th class="text-white text-center">Extensión</th>
                            <th class="text-white text-center">Autor</th>
                            <th class="text-white text-center">Fecha inicio</th>
                            <th class="text-white text-center">Fecha término</th>
                            <th class="text-white text-center">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
            <tr *ngFor="let item of listAnex">

              <td class="text-center" >{{item.title}}</td>
              <td class="text-center"> {{item.extension}} </td>
              <td class="text-center">{{item.username}}</td>
              <td class="text-center">
                {{item.start_date}}
              </td>
              <td class="text-center">{{item.end_date}}</td>
              <td class="text-center"> 

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="download(item.id,item.attachment_url)"  >Descargar</button>
                    <button ngbDropdownItem (click)="stageDelete(item.id)" >Eliminar</button>
                  </div>
                </div>
              </td>
   
            </tbody>
            </ng-container>
                </table>
            </div>
        </section>
    </div>